import * as pharmacy from "../reducers/pharmacyReducer";
import * as providers from "../reducers/searchProvidersReducer";
import * as sso from "../reducers/ssoReducer";
import * as session from "../reducers/sessionReducer";
import * as header from "../reducers/headerReducer";
import * as dashboard from "../reducers/dashboardReducer";
import * as healthplan from "../reducers/healthPlanReducer";
import * as healthsource from "../reducers/healthSourceReducer";
import * as error from "../reducers/errorReducer";
import * as domain from "../reducers/domainReducer";
import * as mapevents from "../reducers/mapEventsReducer";
import * as openschedule from "../reducers/openSchedulingReducer";
import * as locations from "../reducers/searchLocationsReducer";
import * as localCache from "../reducers/localCacheReducer";
import * as pricing from "../reducers/pricingReducer";
import * as myChartDataTile from "../reducers/myChartDataTileReducer";
import * as inMemory from "../reducers/inMemoryReducer";

export const trueInitialState = {
    dashboard: dashboard.dashboardInitialState,
    domain: domain.domainInitialState(),
    error: error.errorInitialState,
    header: header.headerInitialState(),
    healthPlan: healthplan.healthplanInitialState,
    healthSource: healthsource.healthsourceInitialState,
    mapEvents: mapevents.googleMapsInitialState,
    openScheduling: openschedule.schedulingInitialState,
    pharmacy: pharmacy.pharmacyInitialState,
    locations: locations.searchLocationsInitialState,
    providers: providers.searchprovidersInitialState,
    session: session.sessionInitialState(),
    sso: sso.ssoInitialState(),
    localCache: localCache.localCacheInitialState,
    pricing: pricing.pricingInitialState,
    myChartDataTile: myChartDataTile.myChartDataTileInitialState,
    inMemory: inMemory.inMemoryReducerInitialState()
};


